export const resetUserConfig = (reset) => {
  return {
    type: 'RESET_USER_CONFIG',
    payload: reset,
  }
}

export const userConfigError = (error) => {
  return {
    type: 'USER_CONFIG_ERROR',
    payload: error,
  }
}

export const getUserConfig = (data) => {
  return {
    type: 'GET_USER_CONFIG',
    payload: data,
  }
}
export const setUserConfig = (data) => {
  return {
    type: 'SET_USER_CONFIG',
    payload: data,
  }
}

export const addFavoriteTransfer = (data) => {
  return {
    type: 'ADD_FAVORITE_TRANSFER',
    payload: data,
  }
}
export const addedFavoriteTransfer = (configId, type, itemId, message) => {
  return {
    type: 'ADDED_FAVORITE_TRANSFER',
    payload: { configId, type, itemId, message },
  }
}

export const deleteFavoriteTransfer = (configId, itemId) => {
  return {
    type: 'DELETE_FAVORITE_TRANSFER',
    payload: { configId, itemId },
  }
}
export const deletedFavoriteTransfer = (configId, type, itemId, message) => {
  return {
    type: 'DELETED_FAVORITE_TRANSFER',
    payload: { configId, type, itemId, message },
  }
}
